<mat-card class="card-block">
	<mat-card-content>
		<span class="title">Årskostnad</span>
		<span class="" *ngIf="cost?.yearlyTotalMin"
			>{{ cost.yearlyTotalMin | numberSv }} kr</span
		>
		<span class="" *ngIf="cost?.yearlyTotalMax > cost?.yearlyTotalMin"
			> - {{ cost.yearlyTotalMax | numberSv }} kr</span
		>
	</mat-card-content>
</mat-card>
